import { epicRequest, reducersMerge, reduxFetchCreator, serverResponse } from 'app'

import type { TeamSchema } from 'teams'

const update = reduxFetchCreator('teamUpdate', serverResponse<TeamSchema>())

const teamUpdateEpic = epicRequest({
  actionType: update.actions.teamUpdate.type,
  debounce: 1000,
  errorAction: update.actions.teamUpdateError,
  fulfilledAction: update.actions.teamUpdateFulfilled,
  request: ({
    payload,
  }: {
    payload: {
      _avatar?: boolean
      avatar?: Blob
    } & Pick<TeamSchema, 'color_primary' | 'color_secondary' | 'id' | 'name' | 'nickname'>
  }) => {
    const formData = new FormData()
    if (payload.avatar) {
      formData.append('avatar', payload.avatar)
    } else if (payload._avatar) {
      formData.append('_avatar', '1')
    }
    formData.append('name', payload.name)
    formData.append('nickname', payload.nickname)
    formData.append('color_primary', payload.color_primary || '')
    formData.append('color_secondary', payload.color_secondary || '')
    formData.append('_method', 'PUT')

    return {
      body: formData,
      method: 'post',
      url: `sports/soccer/team/${payload.id}`,
    }
  },
  untilTypes: update.actions.teamUpdateCancel.type,
})

const create = reduxFetchCreator('teamCreate', serverResponse<TeamSchema>())

const teamCreateEpic = epicRequest({
  actionType: create.actions.teamCreate.type,
  errorAction: create.actions.teamCreateError,
  // @todo fix type
  fulfilledAction: create.actions.teamCreateFulfilled,
  request: ({
    payload,
  }: {
    payload: { categoryId: string; disciplineId: string; genderId: string; name: string; nickname: string }
  }) => {
    const formData = new FormData()
    Object.entries(payload).forEach(([k, v]) => formData.append(k, v))
    formData.append('_method', 'POST')

    return {
      body: formData,
      method: 'post',
      url: 'sports/soccer/teams',
    }
  },
  // @ts-ignore
  untilTypes: create.actions.teamCreateCancel.type,
})

export const actions = {
  ...create.actions,
  ...update.actions,
}

export const epics = [teamCreateEpic, teamUpdateEpic]

export const reducer = reducersMerge(create.reducer, update.reducer) as typeof create.reducer
